<div class="behavior-preview">
  <nz-alert
    [nzType]="hasValidConfig ? 'info' : 'default'"
    [nzMessage]="'Preview do Comportamento'"
    [nzDescription]="previewText"
    [nzShowIcon]="true">
  </nz-alert>

  <div class="preview-details" *ngIf="eventConfig && hasValidConfig">
    <nz-descriptions nzBordered nzSize="small">
      <nz-descriptions-item nzTitle="Tipo de Evento">
        <nz-tag [nzColor]="eventConfig.eventType === 'onChange' ? 'blue' : 'green'">
          {{ eventConfig.eventType === 'onChange' ? 'Ao Mudar' : 'Ao Inicializar' }}
        </nz-tag>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Modo" *ngIf="eventConfig.mode">
        <nz-tag [nzColor]="eventConfig.mode === 'simple' ? 'blue' : 'orange'">
          {{ eventConfig.mode === 'simple' ? 'Simples' : 'Expert' }}
        </nz-tag>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Condições" *ngIf="eventConfig.simpleConditions">
        {{ eventConfig.simpleConditions.length }} condição(ões)
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Ações" *ngIf="eventConfig.simpleActions">
        {{ eventConfig.simpleActions.length }} ação(ões)
      </nz-descriptions-item>
    </nz-descriptions>
  </div>
</div>



